export * from './Pages';
import routes from './routes';

export default routes;
